import { ContentSaveMoveOutlineIcon } from './ContentSaveMoveOutlineIcon';

/**
 * author: Michael Richins
 * id 12F9DD45-1D74-45E3-84B7-CDE90A3FD174
 * name content-save-move-outline
 * version: 3.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/content-save-move-outline.svg
 * tags
 */
export const FloppyDiscMoveOutlineIcon = ContentSaveMoveOutlineIcon;
export default FloppyDiscMoveOutlineIcon